export default __webpack_public_path__ + "static/media/1958.4de9ecdf.png";